var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"layout-snippet layout-columns"},_vm._l((_vm.layoutCols-1),function(n){return _c('span',{staticClass:"block",class:{ gutter: n % _vm.config+1 === 1, faded: n > _vm.config }},[_c('span',[_vm._v("█")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a44926ce","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layouts/snippets/columns.vue
// module id = 5GFb
// module chunks = 12